export const StickyIfFits = {
  mounted() {
    this.check = () => {
      const el = this.el;
      if (el.scrollHeight > window.innerHeight) {
        el.style.position = "static";
      } else {
        el.style.position = "sticky";
      }
    };

    this.check();
    this.resizeObserver = new ResizeObserver(this.check);
    this.resizeObserver.observe(this.el);
    window.addEventListener("resize", this.check);
  },

  destroyed() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener("resize", this.check);
  },
};
